module.exports = __webpack_public_path__ + "img/next-icon.2e93077a.jpg";